module.exports = __webpack_public_path__ + "static/media/update-listing.7484c8f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Listing/update-listing.svg
// module id = 473
// module chunks = 0